import React, { Component } from 'react'
import Axios from 'axios'
import './FinalConsolidation.css'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { logActivity } from '../Utilities'
class FinalConsolidation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            final_list: [],
            loader: false
        }
    }


    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Final Consolidation',
        //         'module': 'Final Consolidation',
        //         'user_activity': `Final Consolidation for ${localStorage.getItem('dataset_id')} viewed`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Final Consolidation"
        document.getElementById("header").style.opacity = "0.5"
        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
        var body = {
            "dataset_id": localStorage.getItem("dataset_id")
        }
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.consolidation, body)
                .then(response => {
                    this.setState({
                        final_list: response.data.data,
                        loader: false
                    })
                    document.getElementById("header").style.opacity = "1"
                    this.setState({ loader: false })
                })
                .catch(error => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("Error while processing your request")
                    console.log(error)
                    this.setState({ loader: false })
                })
        })
    }

    // Download Cleaned File
    downloadCleanedFile = () => {
        // logActivity([
        //     {
        //         'screen': 'Final Consolidation',
        //         'module': 'Final Consolidation',
        //         'user_activity': `cleaned file downloaded`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        // Body to pass to get cleaned file from download API
        document.getElementById("header").style.opacity = "0.5"
        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "cleaned"
        }
        toast("Please wait while we process your file", { position: toast.POSITION.TOP_CENTER, autoClose: 2500 })
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.download_file, body)
                .then(response => {
                    console.log(response)
                    var current_timestamp = new Date();
                    current_timestamp = current_timestamp.toISOString();
                    let body = {
                        "action": "download",
                        "fileName": (response.data.filename).includes('#') ? (response.data.filename).replace('#', '---') : (response.data.filename),
                        "accountName": "lnclientdata",
                        "containerName": "dcrawfile",
                    }
                    Axios.post(Urls.fileService, body)
                        .then(response => {
                            document.getElementById("header").style.opacity = "1"
                            window.open(response.data.url)
                            this.setState({ loader: false })
                        })
                        .catch(error => {
                            document.getElementById("header").style.opacity = "1"
                            this.setState({ loader: false })
                            toast.error("Error while downloading your file")
                            console.log(error)

                        })
                })
                .catch(error => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("Sorry! Something went wrong.")
                    console.log(error)
                })
        })

    }

    // Download PPT
    downloadPPT = () => {
        // logActivity([
        //     {
        //         'screen': 'Final Consolidation',
        //         'module': 'Final Consolidation',
        //         'user_activity': `ppt file downloaded`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.getElementById("header").style.opacity = "0.5"
        toast.success("This will take time to create your PPT, please wait")
        const body = {
            "dataset_id": localStorage.getItem("dataset_id")
        }
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.download_ppt, body)
                .then(response => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    if (response.data.url) {
                        window.open(response.data.url)
                    }
                    else if (response.data.error) {
                        toast.error(response.data.error)
                    }
                })
                .catch(error => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("Sorry! Something went wrong.")
                    console.log(error)
                })
        })
    }

    // Go back to previous screen
    goBack = () => console.log(this.props.history.push({ pathname: "/spellCorrectionTruck" }))

    goToSummary = () => this.props.history.push({ pathname: "/summaryScreen" })

    gotoReview = () => {
        // logActivity([
        //     {
        //         'screen': 'Final Consolidation',
        //         'module': 'Final Consolidation',
        //         'user_activity': `review for ${localStorage.getItem('dataset_id')}`,
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        sessionStorage.setItem('review-dataset', localStorage.getItem('dataset_id'))
        this.props.history.push({
            pathname: "/review-screen"
        })
    }

    render() {
        const items = this.state.final_list
        return (
            <div id="header">
                <ToastContainer />
                <Loader isLoading={this.state.loader} />
                <div style={{ "margin-bottom": "10%" }} align="center">
                    <button className="btn btn-danger" onClick={this.downloadCleanedFile}>Download</button>
                    <button className="btn btn-primary" onClick={this.downloadPPT}>Download PPT</button>
                    <button className="btn btn-success" onClick={this.gotoReview}>Review</button>
                    <table border="1">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Raw Origin Name</th>
                                <th>Cleaned Origin Name</th>
                                <th>Raw Destination Name</th>
                                <th>Cleaned Destination Name</th>
                                <th>Raw Truck Type</th>
                                <th>Cleaned Truck Type</th>
                                <th>Raw Vendor</th>
                                <th>Cleaned Vendor</th>
                            </tr>
                        </thead>
                        {
                            (items.length === 0) ? (
                                <tbody></tbody>
                            ) : (
                                    <tbody>
                                        {
                                            items.map((item, i) => <tr>
                                                <td> {i + 1} </td>
                                                <td>
                                                    {
                                                        item.raworiginname
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.OriginPoint + ", " + item.OriginDistrict + ", " + item.OriginState
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.rawdestinationname
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.DestinationPoint + ", " + item.DestinationDistrict + ", " + item.DestinationState
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.rawtrucktype
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.Trucktype
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.rawvendor
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.Vendor
                                                    }
                                                </td>

                                            </tr>)
                                        }
                                    </tbody>
                                )
                        }
                    </table>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="100%" />
                </div>
            </div>
        )
    }
}

export default FinalConsolidation
